
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Archery Tournament </h1>
				</div>
			</div>
		</div>
	</div>
	<div class="breadcrumb-bottom-img">
		<img
			src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png" alt="GHRSCF"/>
	</div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
	<div class="container">
		<div class="sec-title text-center">
            <h2>G.H Raisoni Archery Tournament <span >  Amravati 2023 </span></h2>
        </div>
		<p class="text-justify">G H Raisoni University, Amravati, in collaboration with the Maharashtra
			Archery Association, successfully organized the G H Raisoni Memorial Archery
			Competition on 19th June, 2023. The event witnessed enthusiastic
			participation from 85 archers across different categories: under 9, under 14,
			under 17, under 19, and open.
		</p>
		<p class="text-justify">Esteemed dignitaries, including G H Raisoni University Vice Chancellor Dr.
			Vinayak Deshpande and Maharashtra Archery Association Secretary Pramod
			Chandurkar, graced the prestigious competition. Winners were rewarded with
			cash prizes and certificates, adding to the excitement of the day.
		</p>
		<p class="text-justify">The competition showcased exceptional talent and sportsmanship, leaving
			lasting memories for all participants and spectators. Congratulations to all
			the winners!
		</p>
		<p class="text-justify">Congratulations to all the winners! The competition showcased exceptional
			talent and sportsmanship, making it a memorable event for all participants
			and spectators.
		</p>
		<div class="row row-cols-1 row-cols-md-4">
			<div class="col">
				<h6 class="fw-bold"> Indian Round Girls U9</h6>
				<ul class="list-style list-style1">
					<li>1st: Unnati Thakare</li>
					<li>2nd: Indrayani Vaidya</li>
					<li>3rd: Anvi Rasekar</li>
				</ul>
			</div>
			<div class="col">
				<h6 class="fw-bold"> Indian Round Boys U17:</h6>
				<ul class="list-style list-style1">
					<li>1st: Amar Dakore</li>
					<li>2nd: Shivam Khandare</li>
					<li>3rd: Utkarsh Ikhar</li>
				</ul>
			</div>
			<div class="col">
				<h6 class="fw-bold"> Indian Round Girls U17:</h6>
				<ul class="list-style list-style1">
					<li>1st: Ishwari Laybar</li>
					<li>2nd: Anandi Laybar</li>
					<li>3rd: Akshata Savarkar</li>
				</ul>
			</div>
			<div class="col">
				<h6 class="fw-bold"> Indian Round Boys U19:</h6>
				<ul class="list-style list-style1">
					<li>1st: Prasad Chandane</li>
					<li>2nd: Anirudh Khandare</li>
					<li>3rd: Sidhu Chandane</li>
				</ul>
			</div>
			<div class="col mt-4">
				<h6 class="fw-bold"> Boys Senior Indian Round:</h6>
				<ul class="list-style list-style1">
					<li>1st: Sumeet Gurumule</li>
					<li>2nd: Roshan Solanke</li>
					<li>3rd: Jagdish Tarone</li>
				</ul>
			</div>
			<div class="col mt-4">
				<h6 class="fw-bold"> Senior Recovery Boys:</h6>
				<ul class="list-style list-style1">
					<li>1st: Himanshu Charde</li>
					<li>2nd: Ankush Mas</li>
					<li>3rd: Martand Cherle</li>
				</ul>
			</div>
			<div class="col mt-4">
				<h6 class="fw-bold"> Under 14 Girls Category:</h6>
				<ul class="list-style list-style1">
					<li>1st: Tanushka Srinath</li>
					<li>2nd: Survi Devghare</li>
					<li>3rd: Nandini Raut</li>
				</ul>
			</div>
			<div class="col mt-4">
				<h6 class="fw-bold">Under Seventeen Boys Recovery:</h6>
				<ul class="list-style list-style1">
					<li>1st: Gaurav Rathod</li>
					<li>2nd: Aryan Rathod</li>
					<li>3rd: Abhi Pakhale</li>
				</ul>
			</div>
		</div>
	</div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
	<div class="container">
		<div class="border-line-sm"></div>
		<div class="row row-cols-1 row-cols-md-2">
			<div class="col">
				<div class="gall-ery">
					<div class="widget_title inner-title gall-sys shadow-text-sm">
						<h4 class="fw-bold">Media Coverage</h4>
					</div>
					<div class="lightBox--gallery">
						<ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/media1.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/media1.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/media1.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/media2.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/media2.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/media2.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/media3.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/media3.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/media3.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/media4.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/media4.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/media4.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/media5.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/media5.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/media5.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/media6.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/media6.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/media6.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="gall-ery">
					<div class="row row-cols-1 row-cols-md-2">
						<div class="col-md-7">
							<div class="widget_title inner-title gall-sys shadow-text-sm">
								<h4 class="fw-bold">Photos</h4>
							</div>
						</div>
					</div>
					<div class="lightBox--gallery">
						<ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt1.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt1.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt1.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt2.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt2.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt2.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt3.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt3.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt3.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt4.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt4.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt4.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt5.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt5.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt5.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt5.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt5.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt5.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt6.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt6.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt6.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt7.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt7.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt7.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt8.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt8.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryAmravati/amt8.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
